module.exports = __webpack_public_path__ + "img/sinBarrreras24.707ae6c4.jpg";